module.exports = __webpack_public_path__ + "img/Differentiation-NPC_GSE200310.10b23af5.png";